import {

  DENTALEXPENSE_LOADING,
  DENTALEXPENSE_SUCCESS,
  DENTALEXPENSE_FAILED

} from '../actions/submitDentalExpenseActions'

const submitDentalExpense = (state = {
}, action) => {
  switch (action.type) {
    case DENTALEXPENSE_LOADING:
      return Object.assign({}, state, {
        dentalProcedureCodeLoading: true,
        dentalProcedureCode: null,
        dentalProcedureCodeError: null
      })
    case DENTALEXPENSE_SUCCESS:
      return Object.assign({}, state, {
        dentalProcedureCodeLoading: false,
        dentalProcedureCode: action.response,
        dentalProcedureCodeError: null
      })
    case DENTALEXPENSE_FAILED:
      return Object.assign({}, state, {
        dentalProcedureCodeLoading: false,
        dentalProcedureCode: null,
        dentalProcedureCodeError: action.error
      })
    default:
      return state
  }
}

export default submitDentalExpense



// WEBPACK FOOTER //
// ./src/redux/reducers/submitDentalExpenseReducer.js